module.exports = __webpack_public_path__ + "static/media/lock_icon.cb90e466.svg";